import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";
import { ICouponCode } from "../couponcodeModel";

export const getAllCouponCodes = createAsyncThunk(
  "Coupon/FindAllCoupon",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/FindAllCoupon`,
        {}
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Coupon Codes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCouponCode = createAsyncThunk(
  "Coupon/InsertCoupon",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/InsertCoupon`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Coupon Code:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCouponCode = createAsyncThunk(
  "Coupon/UpdateCoupon",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/UpdateCoupon`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Coupon Code:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCouponCodeById = createAsyncThunk(
  "Coupon/FindByIDCoupon",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/FindByIDCoupon`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        CouponCode: result.CouponCode,
        FromDate: result.FromDate ? moment(result.FromDate, "").toDate() : "",
        ToDate: result.ToDate ? moment(result.ToDate).toDate() : "",
        DestinationID: result?.DestinationID,
        UsageCount: result?.UsageCount,
        AmountType: result?.AmountType,
        Percentage: result?.Percentage,
        Amount: result?.Amount,
        MaxAmount: result?.MaxAmount,
        CouponImage: result?.CouponImage,
        CreatedBy: result?.CreatedBy,
        IsActive: result.IsActive ? 1 : 2,
      } as ICouponCode;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Coupon Code:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// export const generateCouponCode = createAsyncThunk(
//   "CouponCode/GenerateCouponCode",
//   async () => {
//     try {
//       const response = await axiosApiInstance.get(
//         `${API_URL}/CouponCode/GenerateCouponCode`
//       );
//       return response.data?.Data?.CouponCode || "";
//     } catch (error: any) {
//       ErrorToast(error?.response?.data?.Details || "Something went wrong");
//       console.error("Error Fetching CouponCodes:", error);
//       return Promise.reject({
//         message: error?.response?.data?.Details || "Something went wrong",
//       });
//     }
//   }
// );

export const deleteCouponCode = createAsyncThunk(
  "Coupon/DeleteCoupon",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/DeleteCoupon`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Coupon Code:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCouponCode = createAsyncThunk(
  "Coupon/FindAllActiveCoupon",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Coupon/FindAllActiveCoupon`
      );
      // SuccessToast(response.data?.Details || "Success");
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetch Coupon Codes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const couponcodeActiveInactive = createAsyncThunk(
  "Coupon/ActiveInActiveCoupon",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/ActiveInActiveCoupon`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Coupon Code:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const couponcodeImageUpload = createAsyncThunk(
  "Coupon/CouponImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/CouponImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
